import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';

document.addEventListener('DOMContentLoaded', function() {
  setupi18n()
});

// --- Demo helpers ---
const isDemoSong = (id) => typeof id === 'string' && id.toLowerCase().includes('demosong');
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

async function setupi18n(){
  await i18n
  .use(LanguageDetector) // Detects user language
  .init({
    fallbackLng: 'en',
    resources: {
      en: {
        translation: enTranslation
      },
      de: {
        translation: deTranslation
      }
    }
  });

  var songId = getUrlParameter('songid');
  if (!isDemoSong(songId)) {
    prependNavbar()
    addListeners()
  } else {
    // add upload your own song button
    prependDemoUploadCTA();
  }

}

function prependDemoUploadCTA() {
  // centered button using your i18n key
  $('body').prepend(
  '<div class="demo-cta">' +
    '<a id="uploadOwnSongBtn" class="demo-cta__btn" href="https://www.fiveloop.io/studio/">' +
      i18n.t('stringUploadYourOwnSong') +
    '</a>' +
  '</div>'
);
}

function prependNavbar(){

  $('body').prepend(
    '<nav class="navbar">' +
      '<div class="navbar_container">' +
        '<a class="navbar_logo" href="index.html" aria-label="FiveLoop home">' +
          '<img src="src/logo-white.png" alt="FiveLoop">' +
          '</img>' +
        '</a>' +
        '<div class="navbar_nav">' +
          /*'<div class="navbar_nav_item">' +
            '<span>'+i18n.t('stringBrowser')+'</span>' +
          '</div>' +*/
          '<div id="premiumInfoBtn" class="navbar_nav_item hidedisplay">' +
            '<span>'+i18n.t('stringGetPremium')+'</span>' +
          '</div>' +
        '</div>' +
        '<div class="navbar_usersettings hide" id ="navbarUsersettings">' +
          '<div class="navbar_userimg">' +
            '<img src="src/icon_user.png">' +
            '</img>' +
          '</div>' +
          '<div class="navbar_usertext">' +
            '<div class="navbar_username">' +
              '<span id="navbarUsername"></span>' +
            '</div>' +
            '<div class="navbar_premiumtag">' +
              '<span id="navbarPremiumTag"></span>' +
            '</div>' +
          '</div>' +
          '<div class="navbar_arrowimg">' +
            '<img src="src/icon_arrowdown.png">' +
            '</img>' +
          '</div>' +
        '</div>' +
        '<div id="navbar_usersettings_dropdown" class="dropdown-content">' +
          '<div id="accountBtn" class="dropdown-content-item">' +
            '<img src="src/icon_user.png"></img>' +
            '<a>'+i18n.t('stringAccount')+'</a>' +
          '</div>' +
          '<div id="storageBtn" class="dropdown-content-item">' +
            '<img src="src/icon_storage.png"></img>' +
            '<a>'+i18n.t('stringStorage')+'</a>' +
          '</div>' +
          '<div id="logoutBtn" class="dropdown-content-item">' +
            '<img src="src/icon_logout.png"></img>' +
            '<a>'+i18n.t('stringLogout')+'</a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</nav>'
  );

}


function addListeners(){
  $("#accountBtn").click(function(){
    window.location.href = "account.html";
  });
  $("#storageBtn").click(function(){
    window.location.href = "storage.html";
  });
  $("#premiumInfoBtn").click(function(){
    window.location.href = "subscribe.html";
  });

  
  $("#navbarUsersettings").click(function(){
    document.getElementById("navbar_usersettings_dropdown").classList.toggle("show");
    document.getElementById("navbarUsersettings").classList.toggle("navbar_usersettings_active");
  });

}

  
  
  
  
  // Close the dropdown menu if the user clicks outside of it
  window.addEventListener('click', function(event) {
    if (!event.target.closest('.tdmore')) {
      var dropdowns = document.getElementsByClassName("dropdown2-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('dropdown2show')) {
          openDropdown.classList.remove('dropdown2show');
          $("#songsTable").find("tr").not(openDropdown.closest("tr")).toggleClass("disabledandalmosthidden")
        }
      }
    }
    if (!event.target.closest('#listtitelMoreImg')) {
      var dropdowns = document.getElementsByClassName("dropdown3-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('dropdown3show')) {
          openDropdown.classList.remove('dropdown3show');
        }
      }
    }
    if (!event.target.closest('.navbar_usersettings')) {
      //document.getElementById("navbarUsersettings").classList.remove("navbar_usersettings_active");
      const userSettings = document.getElementById("navbarUsersettings");
      if (userSettings) {
        userSettings.classList.remove("navbar_usersettings_active");
      }
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  });
  
